import * as React                             from "react";
import { SFC }                                from "react";
import { Button, Divider, Form, Icon, Popup } from "semantic-ui-react";
import DeleteReservationSpecialTime
                                              from "../../../../application/usecase/reservation/DeleteReservationSpecialTime";
import SaveReservationSetting                 from "../../../../application/usecase/reservation/SaveReservationSetting";
import Time                                   from "../../../../domain/fundamentals/date/Time";
import ReservationBusinessDayType             from "../../../../domain/reservation/ReservationBusinessDayType";
import ReservationSetting                     from "../../../../domain/reservation/ReservationSetting";
import { ReservationSettingRepository }       from "../../../../domain/reservation/ReservationSettingRepository";
import ReservationTimeType                    from "../../../../domain/reservation/ReservationTimeType";
import ReservationWeekType                    from "../../../../domain/reservation/ReservationWeekType";
import ValidatorMessage                       from "../../message/ValidatorMessage";
import ReservationBusinessTimeRange           from "./ReservationBusinessTimeRange";
import ReservationSpecialBusinessTimeDisplay  from "./ReservationSpecialBusinessTimeDisplay";
import ReservationSpecialTimeAddButton        from "./ReservationSpecialTimeAddButton";
import ReservationTimeTypeSelector            from "./ReservationTimeTypeSelector";

interface Props {
  reservationSetting: ReservationSetting;
  repository: ReservationSettingRepository;
  saveReservationSetting: SaveReservationSetting;
  deleteReservationSpecialTime: DeleteReservationSpecialTime;
}

const ReservationTimeSetting: SFC<Props> = (props: Props) => {
  const {reservationSetting} = props;
  return (
    <>
      <section style={ {marginBottom: "1rem"} }>
        <Button
          icon
          labelPosition="left"
          positive
          onClick={ () => props.saveReservationSetting.execute(props.reservationSetting) }
        >
          <Icon name="save"/>
          保存する
        </Button>
      </section>

      <ReservationTimeTypeSelector
        label="表示時間の単位"
        reservationSetting={ reservationSetting }
        onChange={ (value: ReservationTimeType) => props.repository.onChangeTimeType(value) }
      />

      <Divider/>

      <Form>
        <Form.Field>
          <label>
            営業時間
            <Popup
              trigger={ <Icon name="help circle" style={ {marginLeft: "0.5rem"} }/> }
              size="mini"
            >
              月曜日から日曜日までの営業時間または定休日を設定します。
            </Popup>
          </label>
          <ReservationBusinessTimeRange
            reservationBusinessTime={ reservationSetting.businessTimes.findByWeekType(ReservationWeekType.MONDAY) }
            onChangeFrom={ (value: Time) => props.repository.onChangeBusinessTimeFrom(ReservationWeekType.MONDAY, value) }
            onChangeTo={ (value: Time) => props.repository.onChangeBusinessTimeTo(ReservationWeekType.MONDAY, value) }
            onChangeHoliday={ (value: ReservationBusinessDayType) => props.repository.onChangeBusinessDayType(ReservationWeekType.MONDAY, value) }
            label="月曜日"
            helpText="月曜日の営業開始時間と営業終了時間、または定休日を設定します。"
          />
          <ValidatorMessage
            target={ `businessTimes[${ reservationSetting.businessTimes.findIndexByWeekType(ReservationWeekType.MONDAY) }].timeValid` }/>
          <Divider/>

          <ReservationBusinessTimeRange
            reservationBusinessTime={ reservationSetting.businessTimes.findByWeekType(ReservationWeekType.TUESDAY) }
            onChangeFrom={ (value: Time) => props.repository.onChangeBusinessTimeFrom(ReservationWeekType.TUESDAY, value) }
            onChangeTo={ (value: Time) => props.repository.onChangeBusinessTimeTo(ReservationWeekType.TUESDAY, value) }
            onChangeHoliday={ (value: ReservationBusinessDayType) => props.repository.onChangeBusinessDayType(ReservationWeekType.TUESDAY, value) }
            label="火曜日"
            helpText="火曜日の営業開始時間と営業終了時間、または定休日を設定します。"
          />
          <ValidatorMessage
            target={ `businessTimes[${ reservationSetting.businessTimes.findIndexByWeekType(ReservationWeekType.TUESDAY) }].timeValid` }/>
          <Divider/>

          <ReservationBusinessTimeRange
            reservationBusinessTime={ reservationSetting.businessTimes.findByWeekType(ReservationWeekType.WEDNESDAY) }
            onChangeFrom={ (value: Time) => props.repository.onChangeBusinessTimeFrom(ReservationWeekType.WEDNESDAY, value) }
            onChangeTo={ (value: Time) => props.repository.onChangeBusinessTimeTo(ReservationWeekType.WEDNESDAY, value) }
            onChangeHoliday={ (value: ReservationBusinessDayType) => props.repository.onChangeBusinessDayType(ReservationWeekType.WEDNESDAY, value) }
            label="水曜日"
            helpText="水曜日の営業開始時間と営業終了時間、または定休日を設定します。"
          />
          <ValidatorMessage
            target={ `businessTimes[${ reservationSetting.businessTimes.findIndexByWeekType(ReservationWeekType.WEDNESDAY) }].timeValid` }/>
          <Divider/>

          <ReservationBusinessTimeRange
            reservationBusinessTime={ reservationSetting.businessTimes.findByWeekType(ReservationWeekType.THURSDAY) }
            onChangeFrom={ (value: Time) => props.repository.onChangeBusinessTimeFrom(ReservationWeekType.THURSDAY, value) }
            onChangeTo={ (value: Time) => props.repository.onChangeBusinessTimeTo(ReservationWeekType.THURSDAY, value) }
            onChangeHoliday={ (value: ReservationBusinessDayType) => props.repository.onChangeBusinessDayType(ReservationWeekType.THURSDAY, value) }
            label="木曜日"
            helpText="木曜日の営業開始時間と営業終了時間、または定休日を設定します。"
          />
          <ValidatorMessage
            target={ `businessTimes[${ reservationSetting.businessTimes.findIndexByWeekType(ReservationWeekType.THURSDAY) }].timeValid` }/>
          <Divider/>

          <ReservationBusinessTimeRange
            reservationBusinessTime={ reservationSetting.businessTimes.findByWeekType(ReservationWeekType.FRIDAY) }
            onChangeFrom={ (value: Time) => props.repository.onChangeBusinessTimeFrom(ReservationWeekType.FRIDAY, value) }
            onChangeTo={ (value: Time) => props.repository.onChangeBusinessTimeTo(ReservationWeekType.FRIDAY, value) }
            onChangeHoliday={ (value: ReservationBusinessDayType) => props.repository.onChangeBusinessDayType(ReservationWeekType.FRIDAY, value) }
            label="金曜日"
            helpText="金曜日の営業開始時間と営業終了時間、または定休日を設定します。"
          />
          <ValidatorMessage
            target={ `businessTimes[${ reservationSetting.businessTimes.findIndexByWeekType(ReservationWeekType.FRIDAY) }].timeValid` }/>
          <Divider/>

          <ReservationBusinessTimeRange
            reservationBusinessTime={ reservationSetting.businessTimes.findByWeekType(ReservationWeekType.SATURDAY) }
            onChangeFrom={ (value: Time) => props.repository.onChangeBusinessTimeFrom(ReservationWeekType.SATURDAY, value) }
            onChangeTo={ (value: Time) => props.repository.onChangeBusinessTimeTo(ReservationWeekType.SATURDAY, value) }
            onChangeHoliday={ (value: ReservationBusinessDayType) => props.repository.onChangeBusinessDayType(ReservationWeekType.SATURDAY, value) }
            label="土曜日"
            helpText="土曜日の営業開始時間と営業終了時間、または定休日を設定します。"
          />
          <ValidatorMessage
            target={ `businessTimes[${ reservationSetting.businessTimes.findIndexByWeekType(ReservationWeekType.SATURDAY) }].timeValid` }/>
          <Divider/>

          <ReservationBusinessTimeRange
            reservationBusinessTime={ reservationSetting.businessTimes.findByWeekType(ReservationWeekType.SUNDAY) }
            onChangeFrom={ (value: Time) => props.repository.onChangeBusinessTimeFrom(ReservationWeekType.SUNDAY, value) }
            onChangeTo={ (value: Time) => props.repository.onChangeBusinessTimeTo(ReservationWeekType.SUNDAY, value) }
            onChangeHoliday={ (value: ReservationBusinessDayType) => props.repository.onChangeBusinessDayType(ReservationWeekType.SUNDAY, value) }
            label="日曜日"
            helpText="日曜日の営業開始時間と営業終了時間、または定休日を設定します。"
          />
          <ValidatorMessage
            target={ `businessTimes[${ reservationSetting.businessTimes.findIndexByWeekType(ReservationWeekType.SUNDAY) }].timeValid` }/>
        </Form.Field>
      </Form>

      <Divider/>

      <ReservationSpecialTimeAddButton
        repository={ props.repository }
      />

      <section style={ {marginTop: "1rem"} }>
        <ReservationSpecialBusinessTimeDisplay
          specialBusinessTimes={ reservationSetting.specialBusinessTimes }
          deleteReservationSpecialTime={ props.deleteReservationSpecialTime }
          repository={ props.repository }
        />
      </section>

      <section style={ {marginTop: "1rem"} }>
        <Button
          icon
          labelPosition="left"
          positive
          onClick={ () => props.saveReservationSetting.execute(props.reservationSetting) }
        >
          <Icon name="save"/>
          保存する
        </Button>
      </section>
    </>
  );
};

export default ReservationTimeSetting;